import Message from '../components/Message';

export default (function (w, d) {
    'use strict';

    function ProfileController() {
        this.updateProfileDetails();
        this.displayInvoiceInformation();
    }

    ProfileController.prototype.updateProfileDetails = function () {
        const ajaxSubmit = $('.save');

        ajaxSubmit.on('click', function (e) {
            const formToSubmit = $(this).data('form');
            $('#' + formToSubmit).submit();
        });

        $(document).on('submit', '.profile-form', function (e) {
            e.preventDefault();

            let form = $(this).serialize();

            $(this).find('[disabled]').each(function () {
                form = form + '&' + $(this).attr('name') + '=' + $(this).val();
            });

            $(this).find('input[type="checkbox"]').each(function() {
                let checkboxStatus = $(this).is(':checked') ? 1 : 0;
                form = form + '&' + $(this).attr('name') + '=' + checkboxStatus;
            });

            $.ajax({
                method: 'post',
                url: $(this).attr('action'),
                data: form,
                success: function(response) {
                    if (response.status === 'success') {
                        new Message('Profile setting successfully saved', 'success');
                        if (response.message) {
                            new Message(response.message, 'success');
                        }
                    } else {
                        new Message(response.message, 'error');
                    }
                },
                error: function () {
                    console.log('Error login...');
                    new Message('Profile setting unsaved', 'error');
                }
            });
        });
    }

    ProfileController.prototype.displayInvoiceInformation = function () {
        $('#invoice').change(function () {
            $('input[name=personal_company]').removeAttr('value');
            $('input[name=company_code]').removeAttr('value');
            $('input[name=personal_company_code]').removeAttr('value');
            $('input[name=personal_company_vat]').removeAttr('value');
            $('#invoice-information').toggle();
        });
    }

    return ProfileController;
}(window, document));

